module.exports = "<my-data-display my-data=\"$$railway.data.myRailways\"\n  my-nature=\"'railway'\"\n  enable-local-search=\"true\"\n  enable-title=\"true\"\n  enable-back=\"true\"\n  enable-badges=\"true\"\n  enable-excel=\"true\"\n  enable-links=\"true\"\n  enable-buttons=\"true\">\n</my-data-display>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/railway/templates/home.html
// module id = 1516
// module chunks = 0